import { useCallback, useEffect } from 'react';
import { isEscapePressed } from 'utils';

type UseCloseOnEscapeOptions = {
  enabled?: boolean;
  capture?: boolean;
};

export default function useCloseOnEscape(
  onClose: () => void,
  options: UseCloseOnEscapeOptions = {},
) {
  const { enabled = true, capture = false } = options;

  const onEscape = useCallback(
    (e: KeyboardEvent) => {
      if (isEscapePressed(e)) {
        e.preventDefault();
        e.stopPropagation();

        // don't remove settimeout
        setTimeout(() => {
          onClose();
        }, 0);
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (!enabled) return;

    document.addEventListener('keydown', onEscape, capture);

    return () => {
      document.removeEventListener('keydown', onEscape, capture);
    };
  }, [onEscape, enabled, capture]);
}
